<script lang="ts">

let { class: className } = $props()
</script>

<svg class={className} height="auto" viewBox="0 -960 960 960" width="auto" fill="#e3e3e3"><path d="M400-107.69 27.69-480 400-852.31l42.54 42.54L112.77-480l329.77 329.77L400-107.69Z"/></svg>